import React, { Component } from 'react'
import { renderTypeIcon } from "../../../Templates/functions"
class AttachmentsList extends Component {
    viewAttachment = (filename) => {
        this.props.viewAttachment(filename)
    }

    checkSelected = (attachmentFilename) => {
        if (this.props.viewingAttachment === attachmentFilename) {
            return "selected"
        } else if (!this.props.viewingAttachment) {
            return "selected"
        } else {
            return ""
        }
    }

    render() {
        return <div style={{height:"calc(100% - 48px)"}}><ul id="preview-attachments-list" className="max-width slide-up">
                {this.props.attachments.map((attachment) => {
                    return <li id="preview-attachments-list-item" key={attachment._id} 
                            className={`flex clickable ${this.checkSelected(attachment.path)}`} 
                            onClick={() => this.viewAttachment(attachment.path)}>
                        {renderTypeIcon(attachment.fileExtension)}
                        <h5>{attachment.path}</h5>
                    </li>
                })}
            </ul></div>
    }
}

export default AttachmentsList